export function calcularEdad(fechaNacimiento) {
  if (typeof fechaNacimiento !== "string") return;
  if (!/^(\d{2})\/(\d{2})\/(\d{4})$/.test(fechaNacimiento)) {
    return "Formato de fecha inválido. Debe ser dd/MM/yyyy";
  }
  
  const [diaNacimiento, mesNacimiento, anioNacimiento] = fechaNacimiento.split("/").map(Number);

  const fechaActual = new Date();
  const diaActual = fechaActual.getDate();
  const mesActual = fechaActual.getMonth() + 1; // Los meses en JavaScript van de 0 a 11
  const anioActual = fechaActual.getFullYear();

  let edad = anioActual - anioNacimiento;

  if (
    mesActual < mesNacimiento ||
    (mesActual === mesNacimiento && diaActual < diaNacimiento)
  ) {
    edad--;
  }

  return edad;
}